import { createSelector } from 'reselect';
import { RootState } from 'store';

export const getAddonServicesState = (state: RootState) => state.addonServices;

export const getActiveAddonServices = createSelector(
    (state: RootState) => state.addonServices,
    state => state.addonServices.filter(addon => addon.active)
);
